module.exports = __webpack_public_path__ + "static/media/arrow-left.c7ebba81.svg";